const data = [
  { id: 1, link: "#", title: "Home" },
  { id: 2, link: "#about", title: "About" },
  { id: 3, link: "#skill", title: "Skill" },
  { id: 4, link: "#services", title: "Services" },
  { id: 5, link: "#portfolio", title: "Projects" },

  { id: 6, link: "#contact", title: "Contact" },
];

export default data;
